module.exports = __webpack_public_path__ + "img/Overall.38c79db1.png";